import React from "react";
import { IMarketCardTitle } from "./iDrivingMarketTitle";

export const DrivingMarketCardTitle: React.FC<IMarketCardTitle> = (
  props: IMarketCardTitle,
) => {
  return (
    <>
      <div
        className={`drivingmarket-title-head ${
          props.className ? props.className : ""
        } `}
      >
        <div className="company-name">{props.title}</div>
        <div className="changeperc">{props.changetitle}</div>
      </div>
    </>
  );
};
